"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfReserveOfferDto = instanceOfReserveOfferDto;
exports.ReserveOfferDtoFromJSON = ReserveOfferDtoFromJSON;
exports.ReserveOfferDtoFromJSONTyped = ReserveOfferDtoFromJSONTyped;
exports.ReserveOfferDtoToJSON = ReserveOfferDtoToJSON;
exports.ReserveOfferDtoToJSONTyped = ReserveOfferDtoToJSONTyped;
/**
 * Check if a given object implements the ReserveOfferDto interface.
 */
function instanceOfReserveOfferDto(value) {
    if (!('hours' in value) || value['hours'] === undefined)
        return false;
    return true;
}
function ReserveOfferDtoFromJSON(json) {
    return ReserveOfferDtoFromJSONTyped(json, false);
}
function ReserveOfferDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'hours': json['hours'],
    };
}
function ReserveOfferDtoToJSON(json) {
    return ReserveOfferDtoToJSONTyped(json, false);
}
function ReserveOfferDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'hours': value['hours'],
    };
}
